/**
 * Always render "MetaPhase" the same way: orange (accent-sunset), bold,
 * linked to metaphase.tech. Use this anywhere we say "Built by MetaPhase",
 * "by MetaPhase", etc.
 */
export function MetaPhaseLink({ className }: { className?: string }) {
  return (
    <a
      href="https://metaphase.tech"
      target="_blank"
      rel="noreferrer"
      className={`text-accent-sunset font-bold hover:text-accent-coral focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-2 rounded ${className ?? ''}`}
    >
      MetaPhase
    </a>
  )
}
